import PropTypes from "prop-types";

function CarIcon({ color, size }) {
  const w = size * 2;
  const h = size;
  return (
    <svg
      width={w}
      height={h}
      viewBox="0 0 48 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      {/* Body */}
      <rect x="2" y="12" width="44" height="9" rx="3" fill={color} />
      {/* Roof */}
      <path d="M12 12 L16 4 L32 4 L36 12 Z" fill={color} />
      {/* Windshields */}
      <path d="M17 11 L19 5.5 L29 5.5 L31 11 Z" fill="rgba(255,255,255,0.3)" />
      {/* Wheels */}
      <circle cx="11" cy="21" r="3.5" fill="#333" />
      <circle cx="11" cy="21" r="1.5" fill="#aaa" />
      <circle cx="37" cy="21" r="3.5" fill="#333" />
      <circle cx="37" cy="21" r="1.5" fill="#aaa" />
      {/* Headlight */}
      <rect x="44" y="14" width="2" height="4" rx="1" fill="#ffe082" />
      {/* Tail light */}
      <rect x="2" y="14" width="2" height="4" rx="1" fill="#ef5350" />
    </svg>
  );
}

CarIcon.defaultProps = {
  color: "#00bfa5",
  size: 20,
};

CarIcon.propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
};

export default CarIcon;
